import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
// import SecureLS from "secure-ls";
import customers from "./modules/customers";
import user from "./modules/user";
import screens from "./modules/screens";
import contacts from "./modules/contacts";
import location from "./modules/location";
import messages from "./modules/messages";
import customerdata from "./modules/customerdata";
import salespersons from "./modules/salespersons";
import products from "./modules/products";
import journals from "./modules/journals";
import appraisal from "./modules/appraisal";
import salesorders from "./modules/salesorders";
import attendances from "./modules/attendance";
import notifications from "./modules/notification.js";
import orders from "./modules/orders"
import auth from "./modules/auth"
import userAdmin from "./modules/userAdmin.js"
import leave from "./modules/leave.js"
import saleslead from "./modules/saleslead.js";
import app from "./modules/app.js";
import banner from "./modules/banner.js";
import fcmNotification from './modules/fcmNotification';
import chat from './modules/chat.js'


// Vuex
Vue.use(Vuex);
Vue.use(VueAxios, axios);

// const ls = new SecureLS({ isCompression: false });

// Create Store
export const store = new Vuex.Store({
  modules: {
    customers,
    user,
    screens,
    contacts,
    location,
    messages,
    customerdata,
    salespersons,
    products,
    journals,
    appraisal,
    salesorders,
    attendances,
    notifications,
    orders,
    auth,
    userAdmin,
    leave,
    saleslead,
    app,
    banner,
    fcmNotification,
    chat,    
  },
  plugins: [createPersistedState({
    // path:['auth'],  // only persist the 'auth' module
    // storage:{
    //   getItem: (key) => ls.get(key),
    //   setItem: (key, value) => ls.set(key, value),
    //   removeItem: (key) => ls.remove(key),
    // },
  })]
});

// const preservedModules = ['device'];
// Add an action for clearing the session storage on logout
store.subscribeAction((action) => {
  if (action.type === "signUserOut") {
    // Object.keys(store._modules.root._children).forEach((modules) => {
    //   // if (modules !== 'device') {
    //   if (!preservedModules.includes(modules)) {
    //     store.commit(`${modules}/RESET_STATE`, null, { root: true });
    //   }
    // });
    
    sessionStorage.clear();
    localStorage.clear(); 
  }
});
